import React from 'react';
import { Box } from '@mui/material';
import CustomButton from 'shared/custom-button/CustomButton';
import { colors } from 'app/providers/theme/colors-type';
import styles from 'features/cancer-protection/step-2/ui/FieldValidationStep.module.css';
import { useAppSelector } from 'shared/utils/hooks/useRedux';
import { CountriesData, FormFieldsStepTwo } from 'entities/cancer-protection/step-2/selsctor';
import { FormFieldsStepOne, Programs } from 'entities/cancer-protection/step-1/selector';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import { IStepTwo } from 'entities/cancer-protection/step-2/types/StepTwo-inerface';
interface FieldValidationStepProps {
    formState: IStepTwo;
    errors: Record<string, string>;
    handleNextStep: () => void;
    handleBack: () => void;
    formatPhone: (phone: string) => string;
}

export const FieldValidationStep: React.FC<FieldValidationStepProps> = ({
    formState,
    errors,
    handleNextStep,
    handleBack,
    formatPhone
}) => {
    const fieldsStepTwo = useAppSelector(FormFieldsStepTwo);
    const fieldsStepOne = useAppSelector(FormFieldsStepOne);

    const formatNumberWithSpaces = (number: number | undefined): string => {
        if (number === undefined) return "Не указано";
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };

    const { Countries } = useAppSelector(CountriesData);
    const isRussia = Countries?.find(country => country.ID === fieldsStepTwo.Insurer.CountryID)?.Name === 'РОССИЯ';
    const programs = useAppSelector(Programs);
    const program = programs.Programs.find(p => p.ID === fieldsStepOne.ProgramId);

    const addDaysToDate = (dateString: string, days: number): string => {
        const [day, month, year] = dateString.split('.').map(Number);
        const date = new Date(year, month - 1, day);
        date.setDate(date.getDate() + days);
        const monthNames = [
            'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
            'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
        ];
        const newDay = date.getDate();
        const newMonth = monthNames[date.getMonth()];
        return `${newDay} ${newMonth}`;
    };

    return (
        <Box>
            <Box className={styles.formBox}>
                <Box className={styles.titleBox}>
                    <h4>Проверка полей</h4>
                    <p>Проверьте введенные данные перед оформлением</p>
                </Box>
                <Box className={styles.textBox}>
                    <Box className={styles.textTitle}>
                        <h4>Страхователь</h4>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>ФИО</span>
                        <p>{fieldsStepTwo.Insurer.LastName} {fieldsStepTwo.Insurer.FirstName} {fieldsStepTwo.Insurer.MiddleName}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Дата рождения</span>
                        <p>{fieldsStepTwo.Insurer.BirthDate}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Пол</span>
                        <p>{fieldsStepTwo.Insurer.Gender}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Почта</span>
                        <p>{fieldsStepTwo.Insurer.Email}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Телефон</span>
                        <p>{formatPhone(fieldsStepTwo.Insurer.Phone)}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Адрес постоянной регистрации</span>
                        <p>{fieldsStepTwo.Insurer.Address}</p>
                    </Box>
                </Box>
                <Box className={styles.textBox}>
                    <Box className={styles.textTitle}>
                        <h4>Паспортные данные</h4>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Гражданство</span>
                        <p>{Countries?.find(country => country.ID === fieldsStepTwo.Insurer.CountryID)?.Name}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Серия и номер паспорта</span>
                        <p>{fieldsStepTwo.Insurer.DocumentSeries} {fieldsStepTwo.Insurer.DocumentNumber}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Дата выдачи</span>
                        <p>{fieldsStepTwo.Insurer.DocumentDate}</p>
                    </Box>
                    {isRussia && (
                        <>
                            <Box className={styles.textItem}>
                                <span>Код подразделения</span>
                                <p>{fieldsStepTwo.Insurer.DepartmentCode}</p>
                            </Box>
                            <Box className={styles.textItem}>
                                <span>Кем выдан</span>
                                <p>{fieldsStepTwo.Insurer.DocumentDepartment}</p>
                            </Box>
                        </>
                    )}
                </Box>
                <Box className={styles.textBox}>
                    <Box className={styles.textTitle}>
                        <h4>Застрахованный</h4>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Является страхователем</span>
                        <p>{fieldsStepTwo.PolicyholderIsSame ? 'Да' : 'Нет'}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>ФИО</span>
                        <p>{fieldsStepTwo.Insureds[0].LastName} {fieldsStepTwo.Insureds[0].FirstName} {fieldsStepTwo.Insureds[0].MiddleName}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Дата рождения</span>
                        <p>{fieldsStepTwo.Insureds[0].BirthDate}</p>
                    </Box>
                </Box>
                <Box className={styles.textBox}>
                    <Box className={styles.textTitle}>
                        <h4>Программа страхования</h4>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Программа</span>
                        <p>{program?.PrintName}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Страховая сумма</span>
                        <p>{formatNumberWithSpaces(program?.InsuranceSum)} <span><CurrencyRubleIcon fontSize="small" /></span></p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Страховая премия</span>
                        <p className={styles.colorText}>{formatNumberWithSpaces(program?.InsurancePremium)} <span><CurrencyRubleIcon fontSize="small" /></span></p>
                    </Box>
                </Box>
                <Box className={styles.textBox}>
                    <Box className={styles.textTitle}>
                        <h4>Срок действия полиса</h4>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Начало действия</span>
                        <p>{fieldsStepTwo.BeginDate}</p>
                    </Box>
                    <Box className={styles.textItem}>
                        <span>Окончание действия</span>
                        <p>{fieldsStepTwo.EndDate}</p>
                    </Box>
                </Box>

                <Box className={styles.textBox}>
                    <Box className={styles.textTitle}>
                        <h4>Срок действия программ в полисе</h4>
                    </Box>
                    <Box className={styles.textItemData}>
                        <Box className={styles.textItem}>
                            <span>Диагностика и лечение злокачественных образований в т.ч злокачественные новообразования in Situ</span>
                            <p>с {addDaysToDate(fieldsStepTwo.BeginDate, 90)}</p>
                        </Box>
                        <span className={styles.textItemDesc}>Дата начала действия договора + 90 дней</span>
                    </Box>
                    <Box className={styles.textItemData}>
                        <Box className={styles.textItem}>
                            <span>Трансплантация костного мозга</span>
                            <p>с {addDaysToDate(fieldsStepTwo.BeginDate, 180)}</p>
                        </Box>
                        <span className={styles.textItemDesc}>Дата начала действия договора + 180 дней</span>
                    </Box>
                </Box>
            </Box>



            <Box className={styles.btnBoxNext}>
                <CustomButton
                    title="Назад"
                    handleClick={handleBack}
                    textColor={colors.primary}
                    backgroundColor="none"
                    width="150px"
                    gap="10px"
                    borderRadius='4px'
                    padding='3px'
                    border='none'
                />
                <CustomButton
                    title="Далее"
                    handleClick={handleNextStep}
                    textColor="white"
                    backgroundColor={colors.primary}
                    width="150px"
                    gap="10px"
                    borderRadius='4px'
                    padding='3px'
                />
            </Box>
        </Box>
    );
};
